@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  colorpass: $color-secondary-green-light;
  colorfail: $color-highlight-red;
  colorpassdirect: $color-primary-green;
  colorfaildirect: $color-primary-red;
}
/* stylelint-enable */
.chartContainerStyle {
  position: 'relative';
  min-height: 13em;
}
